module.exports = __webpack_public_path__ + "img/twitter.832b3dcd.svg";